import { IScrollingBlock } from '../types';
import { distanceBetweenElAndScreenPoint } from '../../../utils/distanceBetweenElAndScreenPoint';

interface IPoint {
  x: number;
  y: number;
}

/**
 * По дефолту, к этой части экрана будем искать самый близкий блок
 * x 0.5 указывает на точку по центру по горизонтали
 * y 0.2 указывает на точку ближе к верхнему краю вьюпорта по вертикали
 * */
const DEFAULT_SCREEN_POINT: IPoint = { x: 0.5, y: 0.2 };

/**
 * Хелпер-класс помогает найти самый близкий к части экрана блок
 * Накидывае в метод recalculate блоки IScrollingBlock, происходит перерасчет
 * Результат (самый близкий блок из переданных в recalculate) хранится в mostClosestToCenterBlock
 * */
export class MostClosestToCenterCalculator {
  private currentMostClosestDistance: number;
  private readonly screenPoint: IPoint;
  public mostClosestToCenterBlock: IScrollingBlock | null = null;

  public constructor(screenPoint?: IPoint) {
    this.screenPoint = screenPoint || DEFAULT_SCREEN_POINT;
  }

  public recalculate(block: IScrollingBlock) {
    /* istanbul ignore if */
    if (!block.ref.current) {
      return;
    }

    const distanceToScreenCenter = distanceBetweenElAndScreenPoint(block.ref.current, this.screenPoint);

    this.currentMostClosestDistance = this.currentMostClosestDistance || distanceToScreenCenter;

    if (distanceToScreenCenter <= this.currentMostClosestDistance) {
      this.currentMostClosestDistance = distanceToScreenCenter;
      this.mostClosestToCenterBlock = block;
    }
  }
}
